/* eslint-disable import/no-unresolved */
import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ShopProductSearch from "components/widgets/user/ShopProductSearch";
import * as Actions from "actions";
import {isMarketPlace} from "helpers/utils";
import ShopHeaderMini from "components/elements/main/ShopHeaderMini";


const ShopProductPageSearch = (props) => {

    const {
        match, history,
        userResetSearchProducts, bootupInfo, wholesale
    } = props;

    const shopId = (isMarketPlace() ? match.params.shopId : bootupInfo.appState.subdomain_shopId);

    const [childData, setChildData] = useState('');

    const handleDataFromChild = (data) => {
        setChildData(data);
    };

    const [state] = useState({
        layoutColumns: 3,
    });


    return (
        <div>
            <ShopHeaderMini {...props} shopId={shopId} includeNav={childData === "PREVIEW"} />
            <ShopProductSearch {...props} shopId={shopId} wholesale={wholesale} isShop={true} sendDataToParent={handleDataFromChild} />
        </div>
    );
};

ShopProductPageSearch.defaultProps = {
  isLoading: false,
};

ShopProductPageSearch.propTypes = {
    userResetSearchProducts: PropTypes.func.isRequired,
    bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.object).isRequired,
};

const shopProductPageSearch = connect(
  ({  bootupInfo }) => ({
    bootupInfo,
      userDetails: bootupInfo.userDetails,
    reqStatus: bootupInfo.reqStatus,
    isLoading: bootupInfo.isLoading,
    serviceError: bootupInfo.serviceError,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(ShopProductPageSearch);

export default shopProductPageSearch;
